<div [formValidation]="secondaryContactForms">
  <app-table [items]="contactForms">
    <ng-template #tableHeader>
      <tr>
        <th style="width: 43px"></th>
        <th style="width: 75px;">Primary</th>
        <th sort field="contact.get('firstName').value">Name</th>
        <th sort field="contact.get('email').value">Email</th>
        <th>Phone</th>
        <th>Actions</th>
      </tr>
    </ng-template>
    <ng-template #tableBody let-contact>
      <tr>
        <td>
          <ng-container *ngIf="!contact.get('isPrimary').value">
            <a (click)="editContact(contact)" title="Edit User" style="cursor: pointer;">
              <i class="fas fa-pen-to-square fa-lg text-primary"></i>
            </a>
          </ng-container>
        </td>
        <td class="text-center">
          <i *ngIf="contact.get('isPrimary').value" class="fas fa-star text-warning"></i>
        </td>
        <td>
          <span>{{contact.get('firstName').value + ' ' + contact.get('lastName').value}}</span>
        </td>
        <td>
          <a [formValidation]="contact.get('email')" [attr.href]="'mailto:' + contact.get('email').value">
            <span>{{contact.get('email').value}}</span>
          </a>
          <ng-container *ngIf="contact.get('emailRecipientType').value">
            <span class="badge rounded-pill bg-primary float-end" style="font-size: 0.8rem;">
              {{contact.get('emailRecipientType').value | emailRecipientType}}
            </span>
          </ng-container>
        </td>
        <td>
          <shared-components-clicktocall [formValidation]="contact.get('phone')" [Phone]="contact.get('phone').value"
            [CountryCode]="countryAbbreviation"></shared-components-clicktocall>
          <i *ngIf="contact.get('canReceiveTextMessages').value && contact.get('phone').value"
            class="fas fa-mobile-alt float-end text-primary" title="Can Receive Text Messages"
            style="font-size:1.2em"></i>
        </td>
        <td>
          <ng-container *ngIf="!contact.get('isPrimary').value">
            <a (click)="deleteContact(contact)" title="Delete User" style="cursor: pointer;">
              <i class="fas fa-trash-alt fa-2x text-danger float-end"></i>
            </a>
          </ng-container>
        </td>
      </tr>
    </ng-template>
  </app-table>
  <div class="row my-3">
    <div class="col-md-12 text-end">
      <button (click)="addContact()" class="btn btn-success">
        <i class="fa fa-plus"></i>
        Add Contact
      </button>
    </div>
  </div>
</div>